import b from 'b_';
import React from 'react';

import './showcase-card_skeleton-view.scss';

export const ShowcaseCardSkeleton = () => {
    return (
        <div className={b('showcase-card', 'skeleton')}>
            <div className={b('skeleton', 'lesson-preview')} />
        </div>
    );
};
